import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../config";

const baseUrl = BASE_URL + "unit-tpyes";

// Create Unit Type
export const createUnit = createAsyncThunk("units/create", async (unitData) => {
  const response = await axios.post(`${baseUrl}/create`, unitData);
  return response.data;
});

// Fetch All Units with Pagination
export const getAllUnits = createAsyncThunk(
  "units/getAll",
  async ({ limit = 1000, offset = 0 }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${baseUrl}/get-all?limit=${limit}&offset=${offset}`
      );
      return {
        units: response.data.results,
        pagination: response.data.pagination,
      };
    } catch (error) {
      return rejectWithValue([]);
    }
  }
);

// Fetch All Units with Pagination
export const fetchAllUnits = createAsyncThunk(
  "units/fetchAll",
  async ({ searchQuery }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${baseUrl}/get-all?${searchQuery}`
      );
      return {
        units: response.data.results,
        pagination: response.data.pagination,
      };
    } catch (error) {
      return rejectWithValue([]);
    }
  }
);

// Get Unit by ID
export const getUnitById = createAsyncThunk("units/getById", async (unitId) => {
  const response = await axios.get(`${baseUrl}/get-by-id/${unitId}`);
  return response.data;
});

// Update Unit Type
export const updateUnit = createAsyncThunk("units/update", async (unitData) => {
  const response = await axios.put(
    `${baseUrl}/update/${unitData.unit_type_id}`,
    unitData
  );
  return response.data;
});

// Delete Unit Type
export const deleteUnit = createAsyncThunk("units/delete", async (unitId) => {
  await axios.delete(`${baseUrl}/delete/${unitId}`);
  return unitId;
});

const unitSlice = createSlice({
  name: "units",
  initialState: {
    units: [],
    pagination: { total: 0, limit: 10, offset: 0, totalPages: 1 },
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(createUnit.pending, (state) => {
        state.loading = true;
      })
      .addCase(createUnit.fulfilled, (state, action) => {
        state.loading = false;
        state.units.push(action.payload);
      })
      .addCase(getAllUnits.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllUnits.fulfilled, (state, action) => {
        state.loading = false;
        state.units = action.payload.units;
        state.pagination = action.payload.pagination;
      })
      .addCase(getAllUnits.rejected, (state) => {
        state.loading = false;
        state.units = [];
      }).addCase(fetchAllUnits.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllUnits.fulfilled, (state, action) => {
        state.loading = false;
        state.units = action.payload.units;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchAllUnits.rejected, (state) => {
        state.loading = false;
        state.units = [];
      })
      .addCase(updateUnit.fulfilled, (state, action) => {
        state.loading = false;
        state.units = state.units.map((unit) =>
          unit.unit_type_id === action.payload.unit_type_id
            ? action.payload
            : unit
        );
      })
      .addCase(deleteUnit.fulfilled, (state, action) => {
        state.units = state.units.filter(
          (unit) => unit.unit_type_id !== action.payload
        );
      })
      .addCase(createUnit.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default unitSlice.reducer;
